import React from 'react';
import { Truck, CheckCircle2 } from 'lucide-react';
export function TruckGlass() {
  const points = ['Truck windshield repair and replacement', 'Semi truck glass and commercial truck glass', 'Fleet account service options', 'Heavy-duty and work truck side, door and rear glass'];
  return <section className="py-16 lg:py-24 bg-slate-50 border-t border-slate-200" data-id="element-631" data-mp="2iq7b5ernk73q">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-632" data-mp="1uz1vp0pmjgty">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-633" data-mp="1v1o575w2s6et">
          <div className="scroll-fade-up" data-id="element-634" data-mp="1q21qes0lmi3w">
            <div className="w-12 h-12 bg-brand-light rounded-lg flex items-center justify-center mb-6" data-id="element-635" data-mp="24002trvd04gr">
              <Truck className="w-6 h-6 text-brand-blue" data-id="element-636" data-mp="1z1ezvkoq36om" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-6" data-id="element-637" data-mp="1z3hzmwfoge6j">
              Truck, Semi & Fleet Glass
            </h2>
            <p className="text-lg text-slate-600 mb-6 leading-relaxed" data-id="element-638" data-mp="3ah3o0fdpqbr0">
              Downtime is expensive. Kosin's Glass repairs and replaces
              windshields and side glass for pickups, work trucks, semi trucks
              and commercial fleets across Southeast Michigan.
            </p>
            <p className="text-slate-600 mb-8 leading-relaxed" data-id="element-639" data-mp="26hqkt87ldq7x">
              Ask about fleet account options to streamline scheduling, billing
              and recurring service for multiple vehicles.
            </p>
            <a href="#quote" className="inline-flex items-center text-brand-blue font-bold hover:text-brand-hover transition-colors group" data-id="element-640" data-mp="1dunlwez07dh5">
              Request a Truck or Fleet Glass Quote
              <span className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-641" data-mp="1npfnruzmcmhq">
                →
              </span>
            </a>
          </div>

          <div className="bg-white rounded-lg p-8 border border-slate-200 shadow-sm scroll-fade-scale" style={{
          animationDelay: '0.15s'
        }} data-id="element-642" data-mp="v1tjslmhbfuc">
            <h3 className="text-xl font-bold text-navy-900 mb-6" data-id="element-643" data-mp="s06wvabwfpvv">
              What's Covered
            </h3>
            <ul className="space-y-5" data-id="element-644" data-mp="nz551ekbag3x">
              {points.map((point, i) => <li key={i} className="flex items-start gap-4" data-id="element-645" data-mp="11q05q3knpqwf" data-mpi={i}>
                  <div className="w-6 h-6 rounded-full bg-brand-light flex items-center justify-center shrink-0 mt-0.5" data-id="element-646" data-mp="ws8ezcvr0att">
                    <CheckCircle2 className="w-4 h-4 text-brand-blue" data-id="element-647" data-mp="91m7pntkiukv" />
                  </div>
                  <span className="text-slate-700 font-medium" data-id="element-648" data-mp="51ke81xzl7go">{point}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}